import BaseUpdateRequest from "../Shared/BaseUpdateRequest";
import GeoPoint from "../Shared/GeoPoint";
import InPersonInterviewAddressType from "./InPersonInterviewAddressType";
import JobWorkerInterviewType from "./JobWorkerInterviewType";

export default class UpdateJobWorkerInterviewFeedbackRequest extends BaseUpdateRequest {
    jobWorkerInterviewId = '';
    workerFeedback = '';
    contactFeedback = '';
}